export enum TestimonialSource {
  LINKEDIN = 'linkedin',
  YOUTUBE = 'youtube',
  LEADER = 'leader',
}

export enum TestimonialFilter {
  ALL = 'all',
  LINKEDIN = 'linkedin',
  YOUTUBE = 'youtube',
  LEADER = 'leader',
}

interface TestimonialBase {
  id: string;
  source: TestimonialSource;
}

export interface LinkedinTestimonial extends TestimonialBase {
  source: TestimonialSource.LINKEDIN;
  name: string;
  role: string;
  company: string;
  avatar: string;
  logo: string;
  quote: string;
  url: string;
}

export interface YoutubeTestimonial extends TestimonialBase {
  source: TestimonialSource.YOUTUBE;
  videoId: string;
  channel: string;
  title: string;
  duration: string;
  views: string;
  start?: number;
}

export interface LeaderTestimonial extends TestimonialBase {
  source: TestimonialSource.LEADER;
  name: string;
  role: string;
  company: string;
  headline: string;
  avatar: string;
  logo: string;
  quote: string;
  url: string;
}

export type Testimonial =
  | LinkedinTestimonial
  | YoutubeTestimonial
  | LeaderTestimonial;

export interface ClientsCommentsProps {
  className?: string;
}
